import React from 'react';
import { Section, Content } from '@layout';
import { H2 } from '@heading';
import styles from './AngleSection.module.scss';
import classNames from 'classnames';

export default function AngleSection({
  className,
  title,
  text,
  contentClassName,
  children,
  ...restProps
}) {
  return (
    <Section
      className={classNames(styles.wrapper, className)}
      wrapContent={false}
      hasBackground
      fullWidth
      {...restProps}
    >
      <div className={styles.contentSpacer}>
        <Content className={classNames(styles.content, contentClassName)}>
          {title && <H2>{title}</H2>}
          {text && <p>{text}</p>}
          {children}
        </Content>
      </div>
    </Section>
  );
}
